"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const material_ui_confirm_1 = require("material-ui-confirm");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
function default_1({ closeNotification }) {
    (0, webview_app_1.useAABBDialogClose)({ open: true, closeDialog: closeNotification, isPageUnloadable: true });
    const { appPushBlocked, androidChannelBlocked } = (0, webview_app_1.useAppPushBlocked)();
    const [needAppPushBlockNotice, setNeedAppPushBlockNotice] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const isAppPushBlockNoticed = (0, functions_1.getCookie)('app_push_block_noticed') === 'yes';
        const isAppPushBlocked = !!appPushBlocked || !!androidChannelBlocked;
        if (isAppPushBlocked && !isAppPushBlockNoticed) {
            setNeedAppPushBlockNotice(true);
        }
    }, [appPushBlocked, androidChannelBlocked]);
    const saveAppPushBlockNoticed = () => {
        (0, functions_1.saveCookie)({ name: 'app_push_block_noticed', value: 'yes', path: '/' });
        setNeedAppPushBlockNotice(false);
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '56px',
        } }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: closeNotification, sx: { position: 'absolute', left: '12px' } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('알림') })), (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ open: needAppPushBlockNotice, title: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "caption1", css: {
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '4px',
                        height: '100%',
                        color: 'var(--white)',
                    } }, { children: [t('앱알림이 꺼져있어요!'), (0, jsx_runtime_1.jsx)(svgs_1.XIconWhiteSvg, { onClick: saveAppPushBlockNoticed })] })), placement: "bottom-end", arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, componentsProps: {
                    tooltip: {
                        sx: {
                            height: '28px',
                            p: '0 10px',
                            borderRadius: '8px',
                            mt: '2px !important',
                            bgcolor: 'var(--gray-80)',
                            '.MuiTooltip-arrow': {
                                color: 'var(--gray-80)',
                            },
                        },
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => {
                        (0, functions_1.goToNotificationSettingConfirm)(confirm);
                    }, sx: { position: 'absolute', right: '12px' } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px' } }) })) }))] })));
}
exports.default = default_1;
